import Model, { attr, belongsTo } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class BookingManagementFeeRuleModel extends Model {
  @attr('string') name!: string;
  @attr('string', { defaultValue: '' }) formula!: string;

  @belongsTo('booking', { async: false, inverse: null })
  booking!: ModelRegistry['booking'];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'booking-management-fee-rule': BookingManagementFeeRuleModel;
  }
}
